import { Reveal } from "./motion";
import { Star } from "lucide-react";
import { REVIEWS } from "@/lib/product";

const Stars = ({ n }) => (
  <div className="flex gap-0.5" aria-label={`${n} out of 5 stars`}>
    {Array.from({ length: 5 }).map((_, i) => (
      <Star
        key={i}
        className={`h-4 w-4 ${i < n ? "fill-blaze text-blaze" : "text-zinc-700"}`}
      />
    ))}
  </div>
);

export const SocialProof = () => {
  return (
    <section
      id="reviews"
      data-testid="social-proof-section"
      className="mx-auto max-w-[1400px] px-5 py-24 sm:px-8 sm:py-32"
    >
      <div className="flex flex-col items-start justify-between gap-6 sm:flex-row sm:items-end">
        <Reveal>
          <p className="mb-3 font-mono text-[11px] uppercase tracking-[0.3em] text-blaze">
            The Receipts
          </p>
          <h2 className="max-w-2xl font-display text-5xl uppercase leading-[0.9] tracking-tight sm:text-7xl">
            12,000 people
            <br />
            can't be wrong.
          </h2>
        </Reveal>
        <Reveal delay={0.1}>
          <div className="flex items-center gap-4">
            <span className="font-display text-6xl leading-none text-blaze">4.9</span>
            <div>
              <Stars n={5} />
              <p className="mt-1 font-mono text-[10px] uppercase tracking-[0.2em] text-zinc-500">
                2,900+ verified reviews
              </p>
            </div>
          </div>
        </Reveal>
      </div>

      <div className="mt-14 grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">
        {REVIEWS.map((r, i) => (
          <Reveal key={r.name} delay={(i % 3) * 0.08}>
            <figure
              data-testid={`review-card-${i}`}
              className="flex h-full flex-col border border-zinc-800 bg-surface-100 p-7 transition-colors duration-300 hover:border-zinc-600"
            >
              <Stars n={r.stars} />
              <blockquote className="mt-4 flex-1 text-base leading-relaxed text-zinc-200">
                "{r.text}"
              </blockquote>
              <figcaption className="mt-6 border-t border-zinc-800 pt-4">
                <div className="font-semibold text-white">{r.name}</div>
                <div className="font-mono text-[10px] uppercase tracking-[0.2em] text-zinc-500">
                  {r.role}
                </div>
              </figcaption>
            </figure>
          </Reveal>
        ))}
      </div>
    </section>
  );
};
